module.exports = __webpack_public_path__ + "img/af.35d7107a.png";